enum TipoEntrega {
    Domiciliar = 1,
    Aeroporto = 2,
}
export default TipoEntrega;
